














import { EnumAppMode } from '@getaccept/lib-shared/src/enums/AppMode';
import { GroupFilter } from '@getaccept/lib-shared/src/enums/group-filter';
import { UserRoleLegacy } from '@getaccept/lib-shared/src/users/types/user-role-legacy';
import { computed, defineComponent } from '@vue/composition-api';
import { useGroupFilter } from '../../../composables/group-filter.composable';
import { useSessionStore } from '../../../session/store/session.store';
import DashboardHeader from '../../components/DashboardHeader.vue';
import DashboardBusinessGrid from './DashboardBusinessGrid.vue';
import DashboardSalesGrid from './DashboardSalesGrid.vue';

export default defineComponent({
  name: 'DashboardNew',
  components: {
    DashboardSalesGrid,
    DashboardBusinessGrid,
    DashboardHeader,
  },
  setup() {
    const sessionStore = useSessionStore();

    const { groupFilter } = useGroupFilter({ allowTeam: false });

    const isAdmin = computed(() => sessionStore.session.user_role === UserRoleLegacy.Admin);
    const showSalesGrid = computed(() => sessionStore.session.app_mode === EnumAppMode.Sales);

    const handleFilter = (filter: GroupFilter) => {
      groupFilter.value = filter;
    };

    const showAll = computed(() => groupFilter.value === GroupFilter.All);

    return {
      groupFilter,
      isAdmin,
      showSalesGrid,
      handleFilter,
      sessionStore,
      showAll,
    };
  },
});
